import { UPDATE_HEADER } from '../actions/update-header';

const initialState = {
  offset: 0,
  height: 0,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_HEADER:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/header.js